import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TabbedNavigation from 'common/components/tabbed_navigation';

const mapStateToProps = () => {
  const links = [{
    url: '/account/payments/requested',
    name: 'Requested',
  }, {
    url: '/account/payments/history',
    name: 'History',
  }];

  return {
    tabs: { links }
  };
}

export default withRouter(connect(mapStateToProps)(TabbedNavigation));



// WEBPACK FOOTER //
// ./account/containers/payout/payments_tabs.js